import { Link, useNavigate } from 'react-router-dom';
import { hasRole } from '@/lib/roles';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown, Plus } from 'lucide-react';

const DEFAULT_CLASS = 'inline-flex items-center gap-1.5 bg-[#98139C] hover:bg-[#7a0f7d] text-white rounded-full font-bold text-sm px-5 h-10 transition-colors';

// The one way to start a request, used by the intake register and the
// Dashboard. Intake chat needs pm (POST /api/intake/items), so roles below pm
// go straight to the guided use case; pm and up choose (ruled Q10).
export default function NewRequestButton({ user, className = DEFAULT_CLASS, testId = 'new-request-button' }) {
  const navigate = useNavigate();
  if (!hasRole(user, 'pm')) {
    return (
      <Link to="/intake/use-case" className={className} data-testid={testId}>
        <Plus size={14} /> New request
      </Link>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={className} data-testid={testId}>
          <Plus size={14} /> New request <ChevronDown size={14} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white dark:bg-[#1a1a2e] border-[#e3e3e3] dark:border-white/10">
        <DropdownMenuItem onSelect={() => navigate('/intake/use-case')} data-testid={`${testId}-use-case`}>
          Guided use case
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => navigate('/intake')} data-testid={`${testId}-chat`}>
          Intake chat
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
